import './_stacked-bar.scss';

import sumBy from 'lodash/sumBy';
import {
  arrayOf,
  node,
  number,
  object,
  oneOf,
  shape,
  string,
} from 'prop-types';
import React from 'react';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';

import {
  campaignLineStatuses,
  STATUS_COLOR_MAP,
} from '../../campaign-editor/constants';

const { DRAFT, READY, PUSHED, LOCKED } = campaignLineStatuses;

export default function StatusStackedBar({ items, tooltip, id, tooltipProps }) {
  const total = sumBy(items, item => item.count);
  return (
    <>
      <div className="d-flex c-stacked-bar w-100" id={id}>
        {items.map(({ count, status }) => {
          const style = {
            width: `${(count / total) * 100}%`,
          };
          return (
            <div
              style={style}
              key={status}
              title={`${status} Campaign lines - ${count}`}
              className={`c-stacked-bar__item bg-${STATUS_COLOR_MAP[status]} h-100`}
            />
          );
        })}
      </div>
      {tooltip && (
        <Tooltip
          innerClassName="bg-white text-body border shadow p-0"
          hideArrow
          fade={false}
          target={id}
          trigger="hover"
          {...tooltipProps}
        >
          {tooltip}
        </Tooltip>
      )}
    </>
  );
}

StatusStackedBar.propTypes = {
  items: arrayOf(
    shape({
      status: oneOf([DRAFT, READY, PUSHED, LOCKED]).isRequired,
      count: number.isRequired,
    }).isRequired,
  ).isRequired,
  tooltip: node,
  id: string,
  // eslint-disable-next-line react/forbid-prop-types
  tooltipProps: object,
};

StatusStackedBar.defaultProps = {
  tooltip: null,
  tooltipProps: {},
  id: '',
};
